import React from 'react'

import { AnimatePresence } from 'motion/react'

import {
  CardCompleted,
  type CardCompletedAction,
  type CardCompletedData,
  type CardCompletedLabels,
  type CardCompletedState,
} from '@/components/molecules/CardCompleted/CardCompleted.tsx'
import { cn } from '@/lib/utils.ts'

import { type CardListState } from '../CardList'

export interface CardListCompletedLabels extends CardCompletedLabels {}

export type CardListCompletedData = Array<CardCompletedData & { id: string }>

export interface CardListCompletedActions {
  onActivate: (requestId: string) => void
  onChangeDonation: (requestId: string, ...args: Parameters<CardCompletedAction['onChangeDonation']>) => void
  onReactivate: (requestId: string) => void
}

export interface CardListCompletedProps
  extends React.HtmlHTMLAttributes<HTMLDivElement>, CardListCompletedActions, Pick<CardCompletedState, 'size'> {
  labels: CardListCompletedLabels
  data?: CardListCompletedData
  state?: CardListState
}

export const CardListCompleted = React.forwardRef<HTMLDivElement, CardListCompletedProps>(
  ({ className, labels, data = [], state, size, onActivate, onChangeDonation, onReactivate, ...props }, ref) => (
    <div className={cn('flex flex-col', className)} ref={ref} {...props}>
      <AnimatePresence initial={false}>
        {data.map((card) => (
          <CardCompleted
            {...card}
            key={card.id}
            labels={labels}
            size={size}
            state={state?.active === card.id ? 'active' : 'default'}
            highlighted={state?.highlighted === card.id}
            onClick={() => {
              onActivate(card.id)
            }}
            onChangeDonation={(value) => {
              onChangeDonation(card.id, value)
            }}
            onReactivate={() => {
              onReactivate(card.id)
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  )
)
